module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "protocol-setup"
    }
  }, [_c('h2', {
    staticClass: "offset",
    attrs: {
      "id": "setup"
    }
  }, [_vm._v("Setup")]), _vm._v(" "), _c('div', {
    staticClass: "setup"
  }, [_c('div', {
    attrs: {
      "id": "deck-list"
    }
  }, [_c('h3', [_vm._v("Deck Map")]), _vm._v(" "), _c('h4', [_vm._v("Containers")]), _vm._v(" "), _c('ul', {
    staticClass: "containers"
  }, _vm._l((_vm.containers), function(container) {
    return _c('li', [_vm._v("\n    ["), _c('a', {
      on: {
        "mouseenter": function($event) {
          _vm.activateContainer(container.slot)
        },
        "mouseout": function($event) {
          _vm.deactivateContainers()
        }
      }
    }, [_vm._v(_vm._s(container.slot))]), _vm._v("] " + _vm._s(container.name) + " (" + _vm._s(container.type) + ")\n    ")])
  })), _vm._v(" "), _c('h4', [_vm._v("Pipettes")]), _vm._v(" "), _c('ul', {
    staticClass: "instruments"
  }, _vm._l((_vm.instruments), function(instrument) {
    return _c('li', [_vm._v("\n        " + _vm._s(instrument.name) + " " + _vm._s(instrument.type) + " (" + _vm._s(_vm.axis(instrument.axis)) + ")\n      ")])
  })), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reagents"
    }
  }, [_vm._v("Reagents")]), _vm._v(" "), _c('div', {
    staticClass: "reagents",
    domProps: {
      "innerHTML": _vm._s(_vm.makeHtml('reagents'))
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "deck-map"
    }
  }, [_c('div', {
    staticClass: "deck"
  }, [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.columns), function(col) {
    return _c('div', {
      staticClass: "deck-col"
    }, _vm._l((_vm.rows), function(row) {
      return _c('div', {
        staticClass: "deck-slot",
        class: {
          occupied: _vm.hasContainer(col + row)
        },
        attrs: {
          "id": col + row
        }
      }, [(_vm.hasContainer(col + row)) ? _c('Container', {
        class: {
          active: _vm.isActive(col + row)
        },
        attrs: {
          "placeable": _vm.getContainer(col + row)
        }
      }) : _c('div', {
        staticClass: "empty"
      }, [_c('p', [_vm._v(_vm._s(col + row))])])], 1)
    }))
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42e2552b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setup.vue
// module id = 155
// module chunks = 2